module.exports = new __parcel__URL__("roadmap-app-skeleton.tpl.a54a882d.svg").toString();